import { Button } from '@peacecover/component';

interface BottomCTAProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

const BottomCTA = ({ onClick, disabled, children }: BottomCTAProps) => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-background-light dark:bg-background-dark px-[24px] py-[12px]"
      style={{
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom))'
      }}
    >
      <Button
        onClick={onClick}
        size="large"
        disabled={disabled}
        className="w-full text-[17px] font-semibold leading-none"
      >
        {children}
      </Button>
    </div>
  );
};

export default BottomCTA;
